import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { PublicProposalBanner } from './public-proposal-banner';

const MAX_WIDTH_CLASS = {
  md: 'max-w-md',
  lg: 'max-w-lg',
} as const;

/**
 * Outer shell shared by the public proposal screens that show a single centered
 * card (OTP verify, send, error, confirmations).
 * Centers horizontally and vertically and renders the banner at the top.
 */
export function PublicProposalCenteredLayout({
  children,
  maxWidth = 'lg',
}: {
  children: ReactNode;
  maxWidth?: keyof typeof MAX_WIDTH_CLASS;
}) {
  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <PublicProposalBanner />
      <div className="flex flex-1 items-center justify-center px-6 py-12">
        <div className={cn('w-full', MAX_WIDTH_CLASS[maxWidth])}>{children}</div>
      </div>
    </div>
  );
}
